import React, { useCallback } from 'react';
import { Icon } from '@picsio/ui';
import { Warning } from '@picsio/icons';
import cn from 'classnames';
import Tooltip from '../../../Tooltip';
import Placeholder from '../../../DetailsBlock/Placeholder';
import ProcessingItem from '../ProcessingItem';
import l10n from '../../../../shared/strings';

const VideoAiItem = ({
  title, text, isError, errorCode, icon: ItemIcon, onClick, tooltipText, inProgress, isPlaceholder,
}) => {
  const isClickable = Boolean(onClick) && !isError && !isPlaceholder;
  const isNoAudioStreamError = isError && errorCode === 'NoSuitableAudioStream';

  const handleClick = useCallback((e) => {
    if (!isClickable) {
      e.preventDefault();
      return;
    }
    if (onClick) onClick(e);
  }, [isClickable, onClick]);

  if (inProgress) {
    return (
      <Placeholder>
        <ProcessingItem item={{ status: 'running', name: title, icon: <Icon><ItemIcon /></Icon> }} />
      </Placeholder>
    );
  }

  return (
    <>
      <div className="video-ai-preview-label">
        <Icon>
          <ItemIcon />
        </Icon>
        <span className="video-ai-preview-label-text">{title}</span>
      </div>
      <Tooltip content={!isClickable ? null : tooltipText} placement="top">
        <div role="presentation" onClick={handleClick} className={cn('video-ai-preview', { 'video-ai-preview-error': !isClickable })}>
          <Choose>
            <When condition={isNoAudioStreamError}>
              <Icon><Warning /></Icon> {l10n.TRANSCRIPT.itemErrorNoAudioStream}
            </When>
            <When condition={isError}>
              <Icon><Warning /></Icon> {title} analysis failed
            </When>
            <Otherwise>
              {text}
            </Otherwise>
          </Choose>
        </div>
      </Tooltip>
    </>
  );
};

export default VideoAiItem;
